import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

export const useFeed = () =>
  useQuery({
    queryKey: ['feed'],
    queryFn: api.getFeed,
    staleTime: 60_000,
  });